export default __webpack_public_path__ + "static/media/dubai.7ec0ec07.jpg";